import toBlob from '../helpers/toBlob';
import entries from 'object.entries';
import values from 'object.values';
import keys from 'object-keys';

if(typeof Object.entries !== 'function') {
  entries.shim();
}

if(typeof Object.values !== 'function') {
  values.shim();
}

if(typeof Object.keys !== 'function') {
  keys.shim();
}
/**
 * Polyfill for canvas.toBlob method
 */
toBlob.init();



// WEBPACK FOOTER //
// ./src/polyfills/index.js